import React,{useState,useEffect} from 'react';
import '../styles/Navbar.css';
import { Button } from '@mui/joy';
import { SiHomeassistant } from "react-icons/si";
import Avatar from '@mui/joy/Avatar';
import Box from '@mui/joy/Box';
import { NavLink ,useLocation, useNavigate} from 'react-router-dom';
import { IoIosPricetags } from "react-icons/io";
import { RiBillFill, RiDingdingLine, RiHome3Fill } from "react-icons/ri";
import { FaCircleQuestion } from "react-icons/fa6";
import { HiInformationCircle } from "react-icons/hi2";
import { MdContactPhone } from "react-icons/md";

import { FiLogIn } from "react-icons/fi";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import Sheet from '@mui/joy/Sheet';
import { Form,Input, SelectPicker,ButtonToolbar ,IconButton, Popover ,Whisper,Loader} from 'rsuite';
import { GiHamburgerMenu } from "react-icons/gi";
import { GrLanguage } from "react-icons/gr";
import { ImProfile } from "react-icons/im";
import { IoNotificationsSharp } from "react-icons/io5";
//! translation:
import { useTranslation } from 'react-i18next';

import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListDivider from '@mui/joy/ListDivider';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';

import "/node_modules/flag-icons/css/flag-icons.min.css";
import { useDispatch,useSelector } from 'react-redux';
import { login } from '../features/UserSlice';
import { RiLogoutCircleRLine } from "react-icons/ri";

import { Menu, MenuItem, IconButton as IconButtons } from '@mui/material';
import LoaderComponent from '../layouts/LoaderComponent';
import { fetchSystemSettingsPublic } from '../features/PricingSettingsSlice';

const CustomComponent = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      // Simulate loading with a 2-second timeout
        const timer = setTimeout(() => setLoading(false), 2000);
      return () => clearTimeout(timer); // Cleanup the timer on component unmount
    }, []);
  
    // Popover content logic
    const popoverContent = (
      <Popover style={{ position: 'absolute', zIndex: 10000000 }}>
        {loading ? (
          <Loader content="Loading..." />
        ) : (
          <div>
            <p>This is a Popover.</p>
            <p>The loading content is loaded.</p>
          </div>
        )}
      </Popover>
    );
  
    return (
      <Whisper
        trigger="click"
        placement="bottom"
        controlId="control-id-bottom"
        speaker={popoverContent} // Always provide a valid React node
      >
        <ButtonToolbar>
          <IconButton
            style={{
                background:'#088fa6',
                border:'1.5px solid rgb(21, 255, 169)',
                borderRadius:'20px',
                '&:hover':{
                    background: '#088fa6',
                    boxShadow:'0 0 6px rgb(21, 255, 169)'
                }
            }}
            circle
            icon={<IoNotificationsSharp color='white'/>}
            appearance="default"
          />
        </ButtonToolbar>
      </Whisper>
    );
  };


  const CustomProfileMenu = ({ userInfo, logOut }) => {
    const [loading, setLoading] = useState(true);

    // Simulate loading with a timeout
    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 2000);
        return () => clearTimeout(timer);
    }, []);

    // Popover content
    const popoverContent = (
        <Popover style={{position: 'absolute', zIndex: 10000000 }}>
            {loading ? (
                <div style={{ textAlign: 'center' }}>
                    <Loader content="Loading..." />
                </div>
            ) : (
                <div>
                    <p style={{ fontWeight: 'bold' }}>{userInfo.name}</p>
                    <ButtonToolbar style={{ display: 'flex', flexDirection: 'column' ,width:'100%'}}>
                        <NavLink to='/dashboard/Profile' style={{ textDecoration: 'none' ,with:'100%'}}>
                            <IconButton  appearance="subtle" color="blue" style={{with:'100%',flexDirection:'row',display:'flex',justifyContent:'space-around',alignItems:'center'}}>
                            <ImProfile  size={24} style={{position:'absolute',left:'2px'}}/>
                                <span>
                                    Profile
                                </span>
                            </IconButton>
                        </NavLink>
                        <NavLink onClick={logOut} style={{ textDecoration: 'none',with:'100%' }}>
                            <IconButton  appearance="subtle" color="red" style={{with:'100%',flexDirection:'row',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                            <RiLogoutCircleRLine   size={24} style={{position:'absolute',left:'2px'}}/>
                                <span>
                                    Log Out
                                </span>
                            </IconButton>
                        </NavLink>
                    </ButtonToolbar>
                </div>
            )}
        </Popover>
    );

    return (
        <div className='menuProfile'>
            <Whisper
                trigger="click"
                placement="bottomEnd"
                speaker={popoverContent}
            >
                <IconButton
                    icon={
                        <Avatar
                            src={`${process.env.REACT_APP_API_URL}/${userInfo.photo}`}
                            alt='Profile'
                            size="sm"
                            style={{
                                border: '1.5px solid rgb(21, 255, 169)',
                                // boxShadow: '0 0 6px rgb(21, 255, 169)',
                            }}
                        />
                    }
                    circle
                    appearance="default"
                    style={{
                        background: 'transparent',
                        borderRadius: '50%',
                        '&:hover': {
                            background: '#088fa6',
                            boxShadow: '0 0 6px rgb(21, 255, 169)',
                        },
                    }}
                />
            </Whisper>
        </div>
    );
};

export default function Navbar() {

    const navigate=useNavigate();
    const location = useLocation();
    const token=localStorage.getItem('token');
    const userInfo=JSON.parse(localStorage.getItem('user'));

    const {t,i18n } = useTranslation();
    const [codeF, setCodeF] = React.useState('gb');
    
    const dispatch = useDispatch();
    const settingsFetchedPublic=useSelector((state)=>state.settings.settingsFetchedPublic);
    const [languages,setLanguages]=useState([]);

    useEffect(()=>{
        dispatch(fetchSystemSettingsPublic());
    },[]);


    useEffect(()=>{
        if(settingsFetchedPublic){
            setLanguages(JSON.parse(settingsFetchedPublic[0]?.language));
            // alert(JSON.stringify(languages))
        }
    },[settingsFetchedPublic]);


    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);

    const [email,setEmail]=useState('');
    const [password,setPassword]=useState('');
    const [errorEmail,setErrorEmail]=useState({error:false});
    const [errorPassword,setErrorPassword]=useState({error:false});

    const [navOpen,setNavOpen]=useState(false);
    const toggleNavBar=()=>{
        setNavOpen(!navOpen);
    }



    const logOut=()=>{
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/');
    }

    const handleLanguageChange = (lng,language) => {
        i18n.changeLanguage(lng);
        setCodeF(language);
    };

    
    const [LoaderState,setLoaderState]=useState(false);

const handleSubmit = async (e) => {
        e.preventDefault();
        setOpen(false);
        setLoaderState(true);

        if (email === '') {
            setErrorEmail({ error: true });
            return;
        } else if (password === '') {
            setErrorPassword({ error: true });
            return;
        }


        try {
            const result = await dispatch(login({ email, password })).unwrap();
            localStorage.setItem('user', JSON.stringify(result.user));
            localStorage.setItem('token', result.token);
            navigate('/dashboard/home/dashboard');
        } catch (error) {
            alert(error.message || 'Login failed');
        }
    };

    const handleClose=()=>{
        setOpen(false);
        setEmail('')
        setPassword('')
        setErrorEmail({error:false});
        setErrorPassword({error:false});

    }

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose2 = () => {
        setAnchorEl(null);
    };

    // const [srcImage,setSrcImage]=useState('');
    
    // const [settingsFetchedPubl,setSettingsFetched]=useState([]);
    const [temp, setTemp] = useState('');


    useEffect(()=>{
        

        if(settingsFetchedPublic>0){
            setTemp(settingsFetchedPublic[0]?.timezone);
        }
    },[settingsFetchedPublic]);

    return (
        <div className='Nav_container' style={{height:navOpen?'330px':'35px'}}>
            {token ? (
                <>
                    
                    <div className='navButtons_div'>
                    <h1 className='logoToken' > {settingsFetchedPublic?.length>0&&(<Avatar src={`${process.env.REACT_APP_API_URL}/${settingsFetchedPublic[settingsFetchedPublic.length-1]?.logo}`} alt='Logo App'/>)}&nbsp;&nbsp;&nbsp;{settingsFetchedPublic?.length>0?settingsFetchedPublic[settingsFetchedPublic.length-1]?.name:<span style={{color:'white'}}>AssetLink</span>}</h1>
                        <div className='tokenDiv'>
                            {
                                languages.length>0&&(
                                    
                            <Select
                                className='SelectLanguageToken'
                                defaultValue={codeF}
                                startDecorator={< GrLanguage color='white'/>}
                                slotProps={{
                                    listbox: {
                                        sx: {
                                            '--ListItemDecorator-size': '44px',
                                            zIndex:1000000000000,

                                        },
                                    },
                                }}
                                sx={{
                                    '--ListItemDecorator-size': '33px',
                                    borderRadius:'20px',
                                    width:'65px',
                                    background:'#088fa6',
                                border:'1px solid rgb(21, 255, 169)',
                                color:'white',
                                '&:hover':{
                                    boxShadow:'0 0 10px rgb(21, 255, 169)',
                                    transition:'0.3s',
                                    background:'#088fa6',
                                },
                                    // height:'30x'
                                    zIndex:1000000000000,

                                }}
                                
                                >
                                    {
                                        languages.some(lang => lang === 'English') && (
                                                <Option value={'gb'} onClick={() => handleLanguageChange('en', 'gb')}>
                                                <ListItemDecorator>
                                                    <span className="fi fi-gb"></span>
                                                </ListItemDecorator>
                                                &nbsp;&nbsp;English
                                                </Option>
                                            )
                                    }
                                    {
                                        languages.some(lang => lang === 'Français') && (
                                            <Option value={'fr'} onClick={() => handleLanguageChange('fr', 'fr')}>
                                            <ListItemDecorator>
                                                <span className="fi fi-fr"></span>
                                            </ListItemDecorator>
                                            &nbsp;&nbsp;Français
                                            </Option>
                                        )
                                    }
                                    {
                                        languages.some(lang => lang === 'العربية') && (
                                            <Option value={'sa'} onClick={() => handleLanguageChange('ar', 'sa')}>
                                            <ListItemDecorator>
                                                <span className="fi fi-sa"></span>
                                            </ListItemDecorator>
                                            &nbsp;&nbsp;العربية
                                            </Option>
                                        )
                                    }
                            </Select>
                                        )
                                    }
                            <CustomComponent />
                            
                            
                            <div className='menuProfile'>
                                <CustomProfileMenu userInfo={userInfo} logOut={logOut}/>
                                
                                {/* <IconButtons onClick={handleClick} >
                                    <Avatar 
                                    style={{
                                        border:'1.5px solid rgb(21, 255, 169)',
                                        borderRadius:'20px',
                                        '&:hover':{
                                            boxShadow:'0 0 6px rgb(21, 255, 169)'
                                        }
                                    }}
                                    src={`${process.env.REACT_APP_API_URL}/${userInfo.photo}`} alt='p'/>
                                </IconButtons>
                                <Menu
                                    anchorEl={anchorEl&&anchorEl}
                                    open={Boolean(anchorEl&&anchorEl)}
                                    onClose={handleClose2}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    sx={{
                                        zIndex:1000000,
                                        minWidth:'300px'
                                    }}
                                >
                                    <MenuItem  disabled>{userInfo.name}</MenuItem>
                                    <MenuItem  className='MuiMenuItem-colorContext'><NavLink to='/dashboard/Profile' className='linkProfile'><ImProfile size={20}/>&nbsp;&nbsp; Profile</NavLink></MenuItem>
                                    <MenuItem className='MuiMenuItem-colorContext menuItemLogout' ><NavLink onClick={logOut} className='linkProfile'><RiLogoutCircleRLine size={25}/>&nbsp;&nbsp; Log Out</NavLink></MenuItem>
                                </Menu> */}
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <nav>
                    <h1 className='logo' style={{
                display:'flex',
                position:'relative',
                left:'10px',
                width:'20%',

                justifyContent:'center',
                alignItems:'center',

            }}>{settingsFetchedPublic&&settingsFetchedPublic?.length>0&&(<Avatar src={`${process.env.REACT_APP_API_URL}/${settingsFetchedPublic[settingsFetchedPublic?.length-1]?.logo}`} alt='Logo App'/>)}&nbsp;&nbsp;&nbsp;{settingsFetchedPublic?.length>0?settingsFetchedPublic[settingsFetchedPublic?.length-1]?.name:""}</h1>
                    <ul className='nav_links' >
                        <NavLink className='navbar_links' to='/'>
                            <RiHome3Fill size={25} className='nav_icons' />&nbsp;&nbsp; <span className='nav_spans'>{t('home')}</span>
                        </NavLink>
                        <NavLink className='navbar_links' to='/HowItWorks'>
                            <FaCircleQuestion size={25} className='nav_icons' />&nbsp;&nbsp; <span className='nav_spans'>{t('work')}</span>
                        </NavLink>
                        <NavLink className='navbar_links' to='/Pricing'>
                            <IoIosPricetags size={25} className='nav_icons' />&nbsp;&nbsp; <span className='nav_spans'>{t('pricing')}</span>
                        </NavLink>
                        <NavLink className='navbar_links' to='/AboutUs'>
                            <HiInformationCircle size={25} className='nav_icons' />&nbsp;&nbsp; <span className='nav_spans'>{t('about')}</span>
                        </NavLink>
                        <NavLink className='navbar_links' to='/ContactUs'>
                            <MdContactPhone size={25} className='nav_icons' />&nbsp;&nbsp; <span className='nav_spans'>{t('contact')}</span>
                        </NavLink>
                    </ul>
                    <Box id="signUpButton" sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '17%' }}>
                        <Button 
                        // className="signInBtn"
                        onClick={handleOpen}
                        sx={{
                            width:'fit-content',
                            height:'40px',
                            borderRadius: '20px',
                            background:'#088fa6',
                            border:'1px solid rgb(21, 255, 169)',
                            '&:hover':{
                                boxShadow:'0 0 10px rgb(21, 255, 169)',
                                transition:'0.3s',
                                background:'#088fa6',

                            }
                        }}
                        className='loginNav'
                        >
                            <FiLogIn />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{t('login')}
                        </Button>
                    </Box>

                    <Box  sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '8%',paddingRight:'5px' }}>
                        <Select
                            className='SelectLanguage'
                            defaultValue={codeF}
                            startDecorator={<GrLanguage color='white'/>}
                            slotProps={{
                                listbox: {
                                    sx: {
                                        '--ListItemDecorator-size': '44px',
                                        zIndex:1000000000000

                                    },
                                },
                            }}
                            sx={{
                                '--ListItemDecorator-size': '33px',
                                borderRadius:'20px',
                                width:'65px',
                                height:'40px',
                                background:'#088fa6',
                                border:'1px solid rgb(21, 255, 169)',
                                color:'white',
                                '&:hover':{
                                    boxShadow:'0 0 10px rgb(21, 255, 169)',
                                    transition:'0.3s',
                                    background:'#088fa6',
                                }
                                ,
                                zIndex:1000000000000,
                            }}
                            
                            >
                                <div style={{zIndex:1000000000000}}>
                                    {languages.some(lang => lang === 'English') && (
                                        <Option value={'gb'} onClick={() => handleLanguageChange('en', 'gb')}>
                                        <ListItemDecorator>
                                            <span className="fi fi-gb"></span>
                                        </ListItemDecorator>
                                        &nbsp;&nbsp;English
                                        </Option>
                                    )}

                                    {languages.some(lang => lang === 'Français') && (
                                        <Option value={'fr'} onClick={() => handleLanguageChange('fr', 'fr')}>
                                        <ListItemDecorator>
                                            <span className="fi fi-fr"></span>
                                        </ListItemDecorator>
                                        &nbsp;&nbsp;Français
                                        </Option>
                                    )}

                                    {languages.some(lang => lang === 'العربية') && (
                                        <Option value={'sa'} onClick={() => handleLanguageChange('ar', 'sa')}>
                                        <ListItemDecorator>
                                            <span className="fi fi-sa"></span>
                                        </ListItemDecorator>
                                        &nbsp;&nbsp;العربية
                                        </Option>
                                    )}
                                </div>
                        </Select>
                    </Box>

                    <Button
                        id='toggleButton'
                        onClick={toggleNavBar}
                    >
                        <GiHamburgerMenu size={25} />
                    </Button>
                </nav>
            )}
            <div >
                <Modal
                    aria-labelledby="modal-title"
                    aria-describedby="modal-desc"
                    open={open}
                    onClose={handleClose}
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                    <Sheet
                    variant="outlined"
                    sx={{
                        width:'70%',
                        borderRadius: 'md',
                        // p: 3,
                        boxShadow: 'lg',
                        display:'flex',
                        height:'70vh'
                        // justifyContent:'space'
                    }}
                    id="sheet"
                    >
                        <ModalClose variant="plain" sx={{ m: 1 }} />
                        <div className='image_wavy' style={{width:'40%'}}>
                            <video className='video' loop autoPlay muted src="/videos/Welcome to HIREPRIP (2).mp4" alt="logImg" style={{
                                width:'100%',
                                position:'relative ',
                                height:'100.5%',
                                zIndex:'100',
                                objectFit:'cover',
                                marginTop:'-1px',
                                marginLeft:'-2px',
                                borderTopLeftRadius:'5px',
                                borderBottomLeftRadius:'5px'
                            }}/>
                            <img src="/assets/login.svg" className='svgLogin' alt="svgLogin" />
                        </div>
                        <div className='form_model' style={{
                            width:'60%',
                            padding:'100px 20px '
                        }}>
                            <div className="formContainer">
                                <center>
                                    <h1 style={{marginTop:'-50px'}}>{t('login')}</h1>
                                </center>
                                <Form fluid>
                                    <Form.Group controlId="email-1">
                                    <Form.ControlLabel className='titles'>{t('email')}</Form.ControlLabel>
                                    <Form.Control name="email" type="email" value={email}  onChange={(value)=>setEmail(value)} className="inputs" />
                                    <Form.HelpText>
                                        <Form.HelpText>{errorEmail.error?(<span style={{color:'red'}}><strong>Error!</strong> Email is required</span>):<span>Required</span>}</Form.HelpText>
                                    </Form.HelpText>
                                    </Form.Group>
                                    <Form.Group controlId="password-1">
                                    <Form.ControlLabel className='titles'>{t('password')}</Form.ControlLabel>
                                    <Form.Control name="password" type="password" value={password}  autoComplete="off" onChange={(value)=>setPassword(value)} className="inputs" />
                                    <Form.HelpText>{errorPassword.error?(<span style={{color:'red'}}><strong>Error!</strong> Password is required</span>):<span>Required</span>}</Form.HelpText>
                                    </Form.Group>
                                </Form>
                            </div>
                            <div className='btnsLogin' style={{
                                width:'100%',
                                display:'flex',
                                justifyContent:'space-evenly',
                                marginTop:'100px'
                            }}>
                            <Button 
                            sx={{
                                borderRadius:'20px',
                                width:'200px',
                                background:' linear-gradient(124deg, rgba(12,46,96,1) 0%, rgba(38,86,17,1) 46%, rgba(9,46,100,1) 100%)'
                            }}
                            className='loginB'
                            onClick={handleSubmit} appearance="primary">
                                <span id='s'><FiLogIn />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>{t('login')}
                            </Button>
                            <Button 
                            sx={{
                                borderRadius:'20px',
                                width:'200px',
                                background:' linear-gradient(124deg, rgba(12,46,96,1) 0%, rgba(38,86,17,1) 46%, rgba(9,46,100,1) 100%)'
                            }}
                            className='cancelB'
                            onClick={() => setOpen(false)} appearance="subtle">
                                {t('cancel')}
                            </Button>
                            </div>
                        </div>
                    </Sheet>
                </Modal>

                {/* Loader modal */}
                <Modal
                    aria-labelledby="modal-title"
                    aria-describedby="modal-desc"
                    open={LoaderState}
                    onClose={() => setLoaderState(false)}
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',zIndex:1000000 }}
                >
                    <LoaderComponent/>
                </Modal>
            </div>
        </div>
    )
}
